"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Loader;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function Loader(props) {
  var _classNames;

  var height = props.height,
      width = props.width,
      hasOverlay = props.hasOverlay,
      color = props.color,
      borderWidth = props.borderWidth,
      borderHeight = props.borderHeight;
  var loader = Object.freeze({
    loader_con: 'fixed top-0 left-0 h-screen w-full bg-gray-200 flex items-center justify-center z-50'
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)((_classNames = {}, _classNames[loader.loader_con] = hasOverlay, _classNames))
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: width,
      height: height,
      border: (borderHeight || parseInt(height, 10) / 5) + "px solid " + (color === 'white' ? '#1191EA' : '#cccccc'),
      borderTop: (borderWidth || parseInt(width, 10) / 5) + "px solid " + color
    },
    className: "animate-spin rounded-full"
  }));
}

Loader.propTypes = {
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  hasOverlay: _propTypes.default.bool,
  color: _propTypes.default.string,
  borderWidth: _propTypes.default.string,
  borderHeight: _propTypes.default.string
};
Loader.defaultProps = {
  height: '50px',
  width: '50px',
  hasOverlay: false,
  color: '#3498db',
  borderWidth: '',
  borderHeight: ''
};